export default "__VITE_ASSET__BnOG$4gR__"